import React from 'react'
import { Link } from 'react-router-dom'

export default function Header() {
  return (
    <header className="container-fluid bg-dark shadow-sm">
      <div className="container">
        <div className="row align-items-center py-3">
          <div className="col-auto">
            <h3 className="mb-0 text-white">
              <Link to="/" className="text-white text-decoration-none">MovieApp</Link>
            </h3>
          </div>
          <nav className="col ms-auto">
            <ul className='list-inline d-flex align-items-center h-100'></ul>
          </nav>
        </div>
      </div>
    </header>
  )
}